module.exports = __webpack_public_path__ + "img/MEDIA101.8166a692.jpg";